import { render, staticRenderFns } from "./osagoInfo.vue?vue&type=template&id=b0b859ce&scoped=true&"
import script from "./osagoInfo.vue?vue&type=script&lang=js&"
export * from "./osagoInfo.vue?vue&type=script&lang=js&"
import style0 from "./osagoInfo.vue?vue&type=style&index=0&id=b0b859ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b859ce",
  null
  
)

export default component.exports